// Rutas de assets de marca. Fuente única — cambiar aquí se propaga a
// Navbar, Footer (vía <Logo>) y schema.js.
// onDark → "Bison" teal claro + "agents" blanco (barras oscuras).
// onLight → "Bison" teal oscuro + "agents" ink (barras claras).
export const WORDMARK = {
  onDark: '/assets/wordmark/wordmark-pure-dark-transparent.svg',
  onLight: '/assets/wordmark/wordmark-tealdark-white-transparent.svg',
};
